export default function TS_Object_Types() {
  return (
    <div>
      <h1>TS Object Types</h1>
      <p>This is the TS Object Types page.</p>
    </div>
  );
}